import {initTagList as initTagListDefault} from '../../components/list-element-tag';
import {initTagList as initTagListRebrand} from '../../../rebrand2020/Hop/components/list-element-tag';
import {INVITATION_EMAIL_SENT} from '../../../events/invitation';
import {pushNotification} from '@malt/joy-v2/src/js/notification';

Hop.defineModule('members-invitation-modal', (root, params) => {
    const inviteForm = root.querySelector('[data-invitation="form-element"]');
    const emailInput = inviteForm.querySelector('[data-hidden-invitation-email]');
    const companyField = root.querySelector('[data-company-id]');
    const initTagList = params.rebrand2020 ? initTagListRebrand : initTagListDefault;
    const tagList = initTagList(inviteForm, emailInput);

    const readEmailsFromForm = () => {
        return emailInput.value
            .trim()
            .split(/\s*,\s*/)
            .reduce((acc, val) => acc.concat(val), [])
            .filter((val) => !!val);
    };

    const onSubmitSuccess = () => {
        $(root).modal('hide');
        pushNotification(Hop.message('company.member.invitation.success.message'), {level: 'success'});
        Hop.events.trigger(INVITATION_EMAIL_SENT);
    };

    function getCurrentCompanyId(companies) {
        const currentCompany = companies.find((company) => company.currentCompany);
        if (currentCompany) {
            return currentCompany.companyId;
        } else {
            Hop.logError("Current company can't be found.");
        }
    }

    function getCompanyOptions() {
        Hop.get('/client/members/options')
            .then((response) => response.json())
            .then((companyOptions) => {
                companyField.value = getCurrentCompanyId(companyOptions);
                setFormListener();
            })
            .catch((error) => handleError(error));
    }

    function setFormListener() {
        inviteForm.addEventListener('submit', submitInviteForm);
    }

    function submitInviteForm(e) {
        e.preventDefault();

        if (!e.target.checkValidity()) {
            return;
        }

        // The enter key will take the current input and turn it into a tag. This is useful when adding a single email.
        e.key = 'Enter';
        tagList.onSubmit(e);

        // read before form is reset
        const emails = readEmailsFromForm();
        const formData = new FormData(inviteForm);
        emails.forEach((email, index) => {
            formData.append(`invitations[${index}].email`, email);
        });

        submitEmailInvitationToEndpoint(formData);
    }

    function submitEmailInvitationToEndpoint(formData) {
        Hop.post(inviteForm.action, formData)
            .then((response) => response.json())
            .then(onSubmitSuccess)
            .then(() => tagList.reset())
            .catch(() => {
                pushNotification(Hop.message('client.invitation.rate.limit.message'), {level: 'warning'});
            });
    }

    function handleError(error) {
        const errorMsg = error.message ? error.message : 'Error when trying to get company options';
        Hop.logError(errorMsg);
    }

    getCompanyOptions();

    return function destroy() {
        inviteForm.removeEventListener('submit', submitInviteForm);
    };
});
